var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('match-media',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var mobile = ref.mobile;
return [_c('v-section',{staticClass:"article-edit-photos",attrs:{"title":mobile ? 'ФОТОГРАФИИ' : ''}},[_c('v-image-uploader-with-preview',{attrs:{"photos":_vm.photos},on:{"add":_vm.addImage,"change":_vm.changePhotos,"remove":_vm.removeImage}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }